export const onDaysSinceAppliedColumnHtml = (e) => {
    if (e.value <= 0) {
        return 'Today';
    } else if (e.value === 1) {
        return <div className='applied'>+1 day</div>;
    } else {
        return <div className={e.value >= 30 ? 'red-highlight applied' : 'applied'}>+{e.value} days</div>;
    }
};
